module.exports = __webpack_public_path__ + "assets/8b16868fb0b6f41a3585bfbfd4d195ed.mp3";